/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration for Best of X (FIRST_TO_WINS) strategy
 * @export
 * @interface BestOfConfig
 */
export interface BestOfConfig {
    /**
     * Allowed round options (e.g., [1, 3, 5, 7])
     * @type {Array<number>}
     * @memberof BestOfConfig
     */
    allowedRounds?: Array<number>;
    /**
     * Default number of rounds
     * @type {number}
     * @memberof BestOfConfig
     */
    defaultRounds?: number;
    /**
     * EventType that determines a win
     * @type {string}
     * @memberof BestOfConfig
     */
    winEventTypeId?: string;
    /**
     * Win event name for display
     * @type {string}
     * @memberof BestOfConfig
     */
    winEventTypeName?: string;
    /**
     * JSON Logic condition for what counts as a win
     * @type {object}
     * @memberof BestOfConfig
     */
    winCondition?: object;
}

/**
 * Check if a given object implements the BestOfConfig interface.
 */
export function instanceOfBestOfConfig(value: object): value is BestOfConfig {
    return true;
}

export function BestOfConfigFromJSON(json: any): BestOfConfig {
    return BestOfConfigFromJSONTyped(json, false);
}

export function BestOfConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BestOfConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedRounds': json['allowedRounds'] == null ? undefined : json['allowedRounds'],
        'defaultRounds': json['defaultRounds'] == null ? undefined : json['defaultRounds'],
        'winEventTypeId': json['winEventTypeId'] == null ? undefined : json['winEventTypeId'],
        'winEventTypeName': json['winEventTypeName'] == null ? undefined : json['winEventTypeName'],
        'winCondition': json['winCondition'] == null ? undefined : json['winCondition'],
    };
}

export function BestOfConfigToJSON(json: any): BestOfConfig {
    return BestOfConfigToJSONTyped(json, false);
}

export function BestOfConfigToJSONTyped(value?: BestOfConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedRounds': value['allowedRounds'],
        'defaultRounds': value['defaultRounds'],
        'winEventTypeId': value['winEventTypeId'],
        'winEventTypeName': value['winEventTypeName'],
        'winCondition': value['winCondition'],
    };
}

